module.exports = __webpack_public_path__ + "img/subscription.d9915da0.jpg";